import type { IAsset } from '../../../../interfaces/asset';
import type { IRequestGetOne } from '../../../../interfaces/requestGetOne';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { translateKey } from '../../../../../translate';
import { FormDivider } from '../../../../elements/common';
import { FormGroup } from '../../../../elements/forms/FormGroup';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { RequestAssetThumbnails } from '../../../episodes/common';

export interface IRequestThumbnails {
    label?: string;
    showFormDivider?: boolean;
}

export function RequestThumbnails(props: ICustomControlRequestReadProps & IRequestThumbnails) {
    const requestFiles = getRequestFiles(props.request);

    if (requestFiles.length > 0) {
        return (
            <>
                <FormGroup>
                    <FormLabel>{props.label || `${translateKey('request.attachment')}: `}</FormLabel>
                    <RequestAssetThumbnails
                        assets={requestFiles}
                        requestId={props.request.id}
                    />
                </FormGroup>
                {props.showFormDivider && <FormDivider />}
            </>
        );
    }

    return null;
}

export function getRequestFiles(request: IRequestGetOne) {
    let requestFiles: IAsset[] = [];
    if (Array.isArray(request.assets)) {
        requestFiles = requestFiles.concat(request.assets);
    }

    if (request.customControlData && Array.isArray(request.customControlData.files)) {
        const newRequestFiles = request.customControlData.files.filter(
            (file: IAsset) => !requestFiles.find((item) => item.id === file.id)
        );
        requestFiles = requestFiles.concat(newRequestFiles);
    }

    return requestFiles;
}
